import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card custom-shadow for-dark-rounded-bg rounded-3 border mb-4 bg-body-bg" }
const _hoisted_2 = { class: "card-body bg-white p-4 rounded-top-3 border-top" }
const _hoisted_3 = {
  class: "card-body bg-white px-4 rounded-bottom-3 border-top",
  style: {"padding-top":"40px","padding-bottom":"42px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SalesOverTime = _resolveComponent("SalesOverTime")!
  const _component_SalesByCategory = _resolveComponent("SalesByCategory")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("div", {
      class: "d-flex justify-content-between align-items-center flex-wrap gap-3",
      style: {"padding":"14.5px 25px"}
    }, [
      _createElementVNode("h3", { class: "mb-0 fs-16 fw-normal text-secondary" }, "Sales Analytics"),
      _createElementVNode("div", {
        class: "dropdown select-dropdown without-border position-relative",
        style: {"right":"-5px"}
      }, [
        _createElementVNode("button", {
          class: "dropdown-toggle bg-transparent border text-body rounded-2",
          style: {"padding-right":"20px"},
          role: "button",
          "data-bs-toggle": "dropdown",
          "aria-expanded": "false"
        }, " Last Month "),
        _createElementVNode("ul", { class: "dropdown-menu dropdown-menu-end bg-white border-0 box-shadow py-3" }, [
          _createElementVNode("li", null, [
            _createElementVNode("button", { class: "dropdown-item text-secondary py-2 px-3" }, " Last Day ")
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("button", { class: "dropdown-item text-secondary py-2 px-3" }, " Last Week ")
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("button", { class: "dropdown-item text-secondary py-2 px-3" }, " Last Month ")
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("button", { class: "dropdown-item text-secondary py-2 px-3" }, " Last Year ")
          ])
        ])
      ])
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_SalesOverTime)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_SalesByCategory)
    ])
  ]))
}